import { approvedDistanceSorter } from '../sorters/approvedDistanceSorter'
import { approvedTimeSorter } from '../sorters/approvedTimeSorter'
import { costSorter } from '../sorters/costSorter'
import { driverSorter } from '../sorters/driverSorter'
import { createDynamicLoadSorter } from '../sorters/dynamicLoadSorter'
import { ordersDoneSorter } from '../sorters/ordersDoneSorter'
import { ordersExecutedSorter } from '../sorters/ordersExecutedSorter'
import { ordersNotCompletedSorter } from '../sorters/ordersNotCompletedSorter'
import { ordersSorter } from '../sorters/ordersSorter'
import { ordersToDoSorter } from '../sorters/ordersToDoSorter'
import { ordersUndeclaredSorter } from '../sorters/ordersUndeclaredSorter'
import { routeEndSorter } from '../sorters/routeEndSorter'
import { routeStartSorter } from '../sorters/routeStartSorter'
import { stopsSorter } from '../sorters/stopsSorter'
import { totalTimeSorter } from '../sorters/totalTimeSorter'
import { vehicleAvatarSorter } from '../sorters/vehicleAvatarSorter'
import { vehicleSorter } from '../sorters/vehicleSorter'

export function getSorterByField(field: string) {
  switch (field) {
    case 'ordersExecutedReschedule':
      return ordersNotCompletedSorter

    case 'ordersExecutedUndeclared':
      return ordersUndeclaredSorter

    case 'ordersExecutedDone':
      return ordersDoneSorter

    case 'ordersExecuted':
      return ordersExecutedSorter

    case 'approvedMileage':
      return approvedDistanceSorter

    case 'approvedTime':
      return approvedTimeSorter

    case 'vehicleAvatar':
      return vehicleAvatarSorter

    case 'vehicleName':
      return vehicleSorter

    case 'driverName':
      return driverSorter

    case 'ordersToDo':
      return ordersToDoSorter

    case 'stopsCount':
      return stopsSorter

    case 'orders':
      return ordersSorter

    case 'routeCost':
      return costSorter

    case 'routeStart':
      return routeStartSorter

    case 'routeEnd':
      return routeEndSorter

    case 'totalTime':
      return totalTimeSorter

    default:
      if (field.startsWith('loads.')) {
        return createDynamicLoadSorter(field.replace('loads.', ''))
      }

      console.warn('No sorter found for field: ', field)
  }
}
